import { createFileRoute } from '@tanstack/react-router';

import { PlatformAssignmentsMonitorScreen } from '@/features/assessments/components/platform/AssignmentsMonitorScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/assessments/assignments/')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: PlatformAssignmentsMonitorScreen,
  staticData: { crumb: 'Assignments' },
});
